export class CommessaModel {
  id: string;
  project_name: string;
  active: boolean;
  cdc_type: string;
  project_description: string;
}